
import React from 'react';
import { Anchor } from 'grommet';

const CellLink = ({link, title, ...props}) => {
    return (
        <Anchor href={`#${link}`} label={title} {...props} />
    );
}

export default CellLink;
